import React from "react"

import * as worldChampionshipsStyles from "../styles/WorldChampionships.module.css"

const WorldChampionships = props => {
  const children = React.Children.toArray(props.children)

  return (
    <>
      <header className="container-fluid p-0">
        {/* <h1>World Championships</h1> */}
      </header>
      <main>
        {children.map((child, index) => (
          <section key={index} className="container-fluid p-0">
            <div className="row g-0">
              <div className={`col-12 ${worldChampionshipsStyles.section}`}>
                {child}
              </div>
            </div>
          </section>
        ))}
      </main>
      <footer className="container-fluid p-0">
        <div className="row">
          <div className="col"></div>
        </div>
      </footer>
    </>
  )
}

export default WorldChampionships
